<template>
  <!-- status idle ise hiç göstermiyoruz -->
  <transition name="fade">
    <div
      v-if="visible"
      class="sync-banner"
    >
      <div class="sync-banner-left">
        <strong>{{ syncMessage }}</strong>
        <small v-if="syncStageLabel" class="sync-stage">
          ({{ syncStageLabel }})
        </small>
      </div>

      <div class="sync-banner-right" v-if="syncPercent !== null">
        <span class="sync-percent">{{ syncPercent }}%</span>
        <small v-if="syncState.total">
          {{ syncState.processed }} / {{ syncState.total }} kayıt
        </small>
      </div>
    </div>
  </transition>
</template>

<script>
import { syncState } from '@/services/syncService';

export default {
  name: 'SyncBanner',

  computed: {
    syncState() {
      return syncState;
    },
    visible() {
      // running veya error durumunda göster
      return this.syncState.status === 'running' || this.syncState.status === 'error';
    },
    syncPercent() {
      if (!this.syncState.total || this.syncState.total <= 0) return null;
      return Math.round((this.syncState.processed / this.syncState.total) * 100);
    },
    syncMessage() {
      if (this.syncState.status === 'error') {
        return this.syncState.message || 'Veriler güncellenirken hata oluştu.';
      }
      return this.syncState.message || 'Veriler senkronize ediliyor...';
    },
    syncStageLabel() {
      switch (this.syncState.stage) {
        case 'checking':    return 'Kontrol ediliyor';
        case 'fetchCari':   return 'Cari listesi alınıyor';
        case 'fetchStok':   return 'Stok listesi alınıyor';
        case 'writeStocks': return 'Stoklar yazılıyor';
        case 'writeCaris':  return 'Cariler yazılıyor';
        case 'finalize':    return 'Son işlemler';
        default:            return '';
      }
    },
  },
};
</script>

<style scoped>
.sync-banner {
  position: sticky;        /* header ile birlikte yukarıda dursun */
  top: 0;
  z-index: 9999;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #fff3cd;
  border-bottom: 1px solid #ffeeba;
  color: #856404;
  padding: 6px 12px;
  font-size: 12px;
}

.sync-banner-left {
  display: flex;
  flex-direction: column;
}

.sync-stage {
  opacity: 0.8;
}

.sync-banner-right {
  text-align: right;
  display: flex;
  flex-direction: column;
}

.sync-percent {
  font-weight: 600;
  font-size: 13px;
}

/* basit fade animasyonu */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/syncBanner.vue